import {
	type AddWsapiImportEntityMappingMutation,
	type CreateWsapiImportMutation,
	type DisableWsapiImportMutation,
	type EnableWsapiImportMutation,
	type ReassignWsapiImportIntegrationMutation,
	type RemoveWsapiImportEntityMappingMutation,
	type SetWsapiImportRunNowMutation,
	type UpdateWsapiImportEntityMappingMutation,
	type UpdateWsapiImportScheduleMutation
} from "~/gql/mutations/wsapiImport.generated";
import { type GetWsapiImportQuery, type GetWsapiImportsQuery } from "~/gql/queries/wsapiImport.generated";

export const wsapiImportEndpoints = {
	AddWsapiImportEntityMapping: {
		invalidatesTags: ["WsapiImport"] as AddTagTypes,
		transformResponse: (res: AddWsapiImportEntityMappingMutation) => res
	},
	CreateWsapiImport: {
		invalidatesTags: ["WsapiImport"] as AddTagTypes,
		transformResponse: (res: CreateWsapiImportMutation) => res
	},
	DisableWsapiImport: {
		invalidatesTags: ["WsapiImport", "IntegrationHealth"] as AddTagTypes,
		transformResponse: (res: DisableWsapiImportMutation) => res
	},
	EnableWsapiImport: {
		invalidatesTags: ["WsapiImport", "IntegrationHealth"] as AddTagTypes,
		transformResponse: (res: EnableWsapiImportMutation) => res
	},
	GetWsapiImport: {
		providesTags: ["WsapiImport"] as AddTagTypes,
		transformResponse: (res: GetWsapiImportQuery) => res
	},
	GetWsapiImports: {
		providesTags: ["WsapiImport"] as AddTagTypes,
		transformResponse: (res: GetWsapiImportsQuery) => res
	},
	ReassignWsapiImportIntegration: {
		invalidatesTags: ["WsapiImport"] as AddTagTypes,
		transformResponse: (res: ReassignWsapiImportIntegrationMutation) => res
	},
	RemoveWsapiImportEntityMapping: {
		invalidatesTags: ["WsapiImport"] as AddTagTypes,
		transformResponse: (res: RemoveWsapiImportEntityMappingMutation) => res
	},
	SetWsapiImportRunNow: {
		invalidatesTags: ["WsapiImport"] as AddTagTypes,
		transformResponse: (res: SetWsapiImportRunNowMutation) => res
	},
	UpdateWsapiImportEntityMapping: {
		invalidatesTags: ["WsapiImport"] as AddTagTypes,
		transformResponse: (res: UpdateWsapiImportEntityMappingMutation) => res
	},
	UpdateWsapiImportSchedule: {
		invalidatesTags: ["WsapiImport"] as AddTagTypes,
		transformResponse: (res: UpdateWsapiImportScheduleMutation) => res
	}
};
